import { axios } from "../../../lib/axios"

export const getEncounterById = (id) => {
    return axios.get(`encounter/${id}`);
}